const RELOAD_GUARD_KEY = 'sc-chunk-reload-at';
const RELOAD_GUARD_WINDOW_MS = 10_000;

const CHUNK_LOAD_ERROR_PATTERN =
  /failed to fetch dynamically imported module|error loading dynamically imported module|importing a module script failed|loading chunk \S+ failed/i;

export function isChunkLoadError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error);
  return CHUNK_LOAD_ERROR_PATTERN.test(message);
}

// Vite chunk URLs are content-hashed and deleted on every deploy (emptyOutDir).
// A tab open since before a deploy can hold stale chunk references, so a single
// automatic reload resolves it. The sessionStorage guard prevents a reload loop
// if reloading doesn't actually fix it (e.g. a genuine outage).
export default function reloadOnChunkLoadError(error: unknown): boolean {
  if (!isChunkLoadError(error)) {
    return false;
  }

  const lastAttempt = Number(sessionStorage.getItem(RELOAD_GUARD_KEY) ?? 0);
  if (Date.now() - lastAttempt < RELOAD_GUARD_WINDOW_MS) {
    return false;
  }

  sessionStorage.setItem(RELOAD_GUARD_KEY, String(Date.now()));
  window.location.reload();
  return true;
}
